import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import { ExternalLink } from "components/common";
import EmbeddedAWSSecurityLakeApp from "./EmbeddedAWSSecurityLakeApp";
const AWSSecurityLakeApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("aws_security_lake.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("aws_security_lake.app.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "aws_security_lake.app.requirement",
      components: { externalLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://aws.amazon.com/console/" }) }
    }
  ), " ")), /* @__PURE__ */ React.createElement(EmbeddedAWSSecurityLakeApp, null));
};
export default AWSSecurityLakeApp;
